/* My Prolearning — Planning : toggle diplôme + animations (vanilla, accessible). */
(function () {
  'use strict';
  var root = document.querySelector('.mpl-plan');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var segs = Array.prototype.slice.call(root.querySelectorAll('.plan-switch .seg'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('.plan-panel'));

  function activate(d) {
    root.setAttribute('data-diploma', d);
    segs.forEach(function (s) {
      var on = s.getAttribute('data-d') === d;
      s.classList.toggle('on', on);
      s.setAttribute('aria-selected', String(on));
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-d') === d;
      p.hidden = !on;
      if (on) p.querySelectorAll('.plan-reveal').forEach(function (el) { el.classList.add('in'); });
    });
  }

  segs.forEach(function (seg, i) {
    seg.addEventListener('click', function () { activate(seg.getAttribute('data-d')); });
    seg.addEventListener('keydown', function (e) {
      var j = null;
      if (e.key === 'ArrowRight') j = (i + 1) % segs.length;
      else if (e.key === 'ArrowLeft') j = (i - 1 + segs.length) % segs.length;
      if (j !== null) { e.preventDefault(); segs[j].focus(); activate(segs[j].getAttribute('data-d')); }
    });
  });

  /* reveal au scroll */
  function fire(el) { el.classList.add('in'); }
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { fire(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    root.querySelectorAll('.plan-reveal').forEach(function (el) {
      var panel = el.closest('.plan-panel');
      if (panel && panel.hidden) return;
      io.observe(el);
    });
  } else {
    root.querySelectorAll('.plan-reveal').forEach(fire);
  }

  /* parallaxe légère du fond */
  if (!reduce) {
    var cals = root.querySelectorAll('.plan-bg .cal');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset;
        cals.forEach(function (g, i) { g.style.transform = 'translateY(' + (y * ((i % 3 + 1) * 0.03)) + 'px)'; });
        ticking = false;
      });
    }, { passive: true });
  }
})();
